// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-contact-not-sms{width:100%;font-size:16px;padding-top:12;padding-bottom:14px}.c-contact-not-sms__info-card{display:flex;margin-top:16px;font-weight:500;color:var(--text);justify-content:center}.c-contact-not-sms__info-card-icon{margin-right:8px}", ""]);
// Exports
module.exports = exports;
